export interface AvailabilitySlot {
  id: string;
  details: string;
  offerDiscountType: string;
  percentage: number;
  offerDiscountTarget: AvailabilitySlotTarget;
  type: AvailabilitySlotType;
  isAvailableOnMonday: boolean;
  isAvailableOnTuesday: boolean;
  isAvailableOnWednesday: boolean;
  isAvailableOnThursday: boolean;
  isAvailableOnFriday: boolean;
  isAvailableOnSaturday: boolean;
  isAvailableOnSunday: boolean;
  startTime: string;
  endTime: string;
  termsAndConditions: string[];
}

export enum AvailabilitySlotType {
  BREAKFAST = 'BREAKFAST',
  LUNCH = 'LUNCH',
  DINNER = 'DINNER',
  // ALL_DAY = 'ALL_DAY'
}

export enum DetailsType {
  PERCENT_OFF = 'PERCENT_OFF',
  OTHER = 'OTHER',
}

export enum DiscountTarget {
  FOOD = 'food',
  DRINKS = 'drinks',
  BILL = 'total bill'
}

export enum AvailabilitySlotTarget {
  FOOD = 'FOOD',
  DRINKS = 'DRINKS',
  BILL = 'BILL'
}

export function mapDiscountTargetToAvailabilitySlotTarget(discount: DiscountTarget): AvailabilitySlotTarget {
  switch (discount) {
    case DiscountTarget.FOOD:
      return AvailabilitySlotTarget.FOOD;
    case DiscountTarget.DRINKS:
      return AvailabilitySlotTarget.DRINKS;
    case DiscountTarget.BILL:
      return AvailabilitySlotTarget.BILL;
    default:
      throw new Error('Invalid DiscountTarget value');
  }
}

export function mapAvailabilitySlotTargetToDiscountTarget(slot: AvailabilitySlotTarget): DiscountTarget {
  switch (slot) {
    case AvailabilitySlotTarget.FOOD:
      return DiscountTarget.FOOD;
    case AvailabilitySlotTarget.DRINKS:
      return DiscountTarget.DRINKS;
    case AvailabilitySlotTarget.BILL:
      return DiscountTarget.BILL;
    default:
      throw new Error('Invalid AvailabilitySlotTarget value');
  }
}

export function emptyAvailabilitySlot(): AvailabilitySlot {
  return {
    id: null,
    details: null,
    offerDiscountType: DetailsType.OTHER,
    percentage: null,
    offerDiscountTarget: null,
    type: null,
    isAvailableOnMonday: false,
    isAvailableOnTuesday: false,
    isAvailableOnWednesday: false,
    isAvailableOnThursday: false,
    isAvailableOnFriday: false,
    isAvailableOnSaturday: false,
    isAvailableOnSunday: false,
    startTime: null,
    endTime: null,
    termsAndConditions: [],
  };
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/offers/interfaces/availability-slots.inferfaces.ts